import styled from "styled-components";
import { palette } from "styled-theme";
import WithDirection from "../../../settings/withDirection";
import Color from "../../../assets/Color";
import background from "../../../assets/img/signup-background.png";
import recycleIcon from "../../../assets/icon/recycle-grey.png";
import pingIcon from "../../../assets/icon/ping-grey.png";
import bagIcon from "../../../assets/icon/bag-full-grey.png";

const CustomPageStyle = styled.div`
  border:1px solid rgb(255 255 255 / 0%);
  width: 100%;
  min-height: 100vh;
  background-color: ${Color.Sand};

  .backgroundImg {

    background: url(${background}) no-repeat center bottom;
    width: 100%;
    min-height: 95vh;
    background-size: contain;
  }
  

  .pg-header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100; 
    padding: 30px;
  }

  .pg-header.padding-0 {
    padding: 20px 0;
    background-color: #F7F7F7;
  }

  .pg-content {
    margin-top: 20px;
      
    @media only screen and (max-width: 767px) {
      margin-top: 10px;
    }

    @media (max-width: 580px) {
      margin-top: 60px;
    }
  }

  .backBtn {
    position: fixed;
    top: 20px;
    left: 25px;
    font-size: 20px;

    span {
      font-size: 14px;
    }
  }

  .font-17 {
    font-size: 17px;
    line-height: 1.2;
  }

  .font-20 {
    font-size: 20px;
  }

  .font-24 {
    font-size: 24px;
  }

  .font-30 {
    font-size: 30px;
  }

  .font-bold {
    font-weight: bold;
  }

  .color-white {
    color: ${Color.White};
  }

  .color-grey {    
    color: ${Color.DustyGrey};
  }

  .color-primary {    
    color: ${Color.Secondary};
  }

  .width100 {
    width: 100%;
  }
  
  .align-middle { 
    display: flex;
    align-items: center;
    justify-content: center;
  }


  .ant-input-group .ant-input{
    text-align: left;
  }
 
  .ant-input-group{
    margin-bottom: 0px;

    .ant-select{
      width: 100%
    }
  }

  .isoImgWrapper {
    img {
      width: 100%;
      object-fit: cover;
    }
  }

  .isoIconWrapper {
    img {
      width: 45px;
      object-fit: cover;
    }
  }

  .bottomBackground {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .bottomText{
    position: fixed;
    bottom: 100px;
    left: 0;
    width: 100%;
  }

  .bottomText.b15{
    bottom: 15px;
  }

  
  .isoLoginContentWrapper {
    margin: 40px 10px 0 10px;
  }

  .isoLoginContent {
    font-size: 19px;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 25px;
    position: relative;

    @media only screen and (max-width: 767px) {
      width: 100%;
      padding: 30px 20px;
    }

    .isoLogoWrapper {
      width: 100%;
      display: flex;
      margin-bottom: 25px;
      justify-content: center;
      flex-shrink: 0;

      a {
        font-size: 24px;
        font-weight: 300;
        line-height: 1;
        text-transform: uppercase;
        color: ${palette("secondary", 2)};
      }
    }

    .img-verify {
      text-align: -webkit-center;
      
      .isoImgWrapper {
        width: 200px;
        height: 230px;

        img {
          width: 100%;
          object-fit: cover;
        }
      }
    }

    .isoSignInForm {
      width: 100%;
      display: flex;
      flex-shrink: 0;
      flex-direction: column;

      .isoInputWrapper {
        margin-bottom: 10px;
        text-align: center;
        display: block;
        &:last-of-type {
          margin-bottom: 0;
        }

        .ant-input-group{
          margin-bottom: 0px;

          .ant-select{
            width: 100%
          }
        }

        .ant-form-item{
          margin-bottom: 0px;
          padding-bottom:0;

          .ant-form-item-label label{
            font-size: 10px;
          }
          input {
            &::-webkit-input-placeholder {
              color: ${palette("grayscale", 0)};
            }

            &:-moz-placeholder {
              color: ${palette("grayscale", 0)};
            }

            &::-moz-placeholder {
              color: ${palette("grayscale", 0)};
            }
            &:-ms-input-placeholder {
              color: ${palette("grayscale", 0)};
            }
          }
        }

        input[type="password"]{
          width: 100%
        }
        }

      .isoHelperText {
        font-size: 12px;
        font-weight: 400;
        line-height: 1.2;
        color: ${palette("grayscale", 1)};
        padding-left: ${props =>
          props["data-rtl"] === "rtl" ? "inherit" : "13px"};
        padding-right: ${props =>
          props["data-rtl"] === "rtl" ? "13px" : "inherit"};
        margin: 15px 0;
        position: relative;
        display: flex;
        align-items: center;

        &:before {
          content: "*";
          color: ${palette("error", 0)};
          padding-right: 3px;
          font-size: 14px;
          line-height: 1;
          position: absolute;
          top: 2px;
          left: ${props => (props["data-rtl"] === "rtl" ? "inherit" : "0")};
          right: ${props => (props["data-rtl"] === "rtl" ? "0" : "inherit")};
        }
      }

      .isoHelperWrapper {
        margin-top: 25px;
        flex-direction: column;

        .isoForgotPass{
          cursor: pointer;
            font-size:12px;
            text-transform: uppercase;
            color: ${palette("text", 3)};
            &:hover{
              color:${Color.SoftOrange}
            }
        }
      }

      .isoOtherLogin {
        padding-top: 40px;
        margin-top: 35px;
        border-top: 1px dashed ${palette("grayscale", 2)};

        > a {
          display: flex;
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        button {
          width: 100%;
          height: 42px;
          border: 0;
          font-weight: 500;


          &.btnFacebook {
            background-color: #3b5998;

            &:hover {
              background-color: darken(#3b5998, 5%);
            }
          }

          &.btnGooglePlus {
            background-color: #dd4b39;
            margin-top: 15px;

            &:hover {
              background-color: darken(#dd4b39, 5%);
            }
          }

          &.btnAuthZero {
            background-color: #e14615;
            margin-top: 15px;

            &:hover {
              background-color: darken(#e14615, 5%);
            }
          }

          &.btnFirebase {
            background-color: ${palette("color", 5)};
            margin-top: 15px;

            &:hover {
              background-color: ${palette("color", 6)};
            }
          }
        }
      }

     .width30{
       width: 30%
     }

     .width68{
      width: 68%
     }

     .ml2{
       margin-left: 2%;
     }

     .mt25px{
      margin-top: 5%;
     }
    }
  }

  .width100 {
    width: 100%;
  }

  .alert-msg{
    font-size: 20px;
    margin: 10%;
    padding-bottom: 30px;
  }


  .bottom-btn {
    border-radius: 10px;
    text-transform: capitalize !important;
    height: 55px !important;
    font-size: 16px !important;
    font-weight: bold !important;
  }

  .bottom-btn.green-btn {
    background: ${palette("grayscale", 13)};
    color: ${Color.White};
  }
  
  .bottom-btn.grey-btn {  
    background: ${palette("grayscale", 12)};
    color: ${palette("grayscale", 13)};
  }

  .profile-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  
  }

  .dashboard {
    display: flex;
    gap: 5%;
    backdrop-filter: blur(12px);
    border-radius: 20px;
    margin-bottom: 15px;
    color: rgb(87 87 87);
  }

  .card {
    width: 50%;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: 10px;
    transition: transform 0.3s;
    background: radial-gradient(circle at center, rgb(255 255 255) 0%, /* bright center */ rgb(250 250 250) 60%, /* mid color */ rgb(250 250 250) 100%);
    border: 1px solid rgb(231 231 231);
  }
    
  .card.full-width {
    width: 100%;
  }

  .icon-box:active {
    transform: translateY(-5px);
  }

  .icon {
    width: 90px;
    height: 90px;
    border-radius: 12px;
    margin: 0 auto;
  }

  .icon.small {
    width: 50px;
    height: 50px;
    margin: 0;
  }

  .switch-btn {
    padding: 10px;
  }

  /* Example color-coded icons */
  .icon.recycle-start {
    background: url(${recycleIcon}) no-repeat center/100%;
  }
  .icon.ping-test {
    background: url(${pingIcon}) no-repeat center/60%;
  }
  .icon.bag-full {
    background: url(${bagIcon}) no-repeat center/50%;
  }



  .status-circle {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    display: inline-block;
    margin: 5px;
    box-shadow: 0 0 8px rgba(0,0,0,0.1);
  }

  /* Different status colors */
  .free_to_use {
    background-color: ${Color.Primary};
    box-shadow: 0 0 10px ${Color.Primary};
  }

  .in_use {
    background-color: ${Color.Amber};
    box-shadow: 0 0 10px ${Color.Amber};
  }

  .process_end {
    background-color: ${Color.Flamingo};
    box-shadow: 0 0 10px ${Color.Flamingo};
  }

  .error {
    background-color: ${Color.Carnation};
    box-shadow: 0 0 10px ${Color.Carnation};
  }

  .offline {
    background-color: ${Color.DustyGrey};
    box-shadow: 0 0 10px ${Color.DustyGrey};
  }

  @keyframes pulse {
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.2); opacity: 0.7; }
    100% { transform: scale(1); opacity: 1; }
  }

  

  .scan-qr-container {
    background-color: ${Color.Black} !important;
  }


  /*===== End Upload Image Form =====*/

  
  .isoImageCon {
    
    .isoIcon {
      border: 2px dashed ${Color.Primary};
      text-align: center;
      border-radius: 4px; 
      padding: 15px;      
    }


    .file-wrapper{
      background: ${Color.Sand};
      border: 1px solid ${Color.Mercury};
      width: 100%;
      text-align: center;
      display: table;

      img {
        height: auto;
        object-fit: cover;
        width: 30%;
      }

      .image-container {
        padding: 15px;
        height: 100px;
        width: auto;
      }

      .table-cell {
        display: table-cell;
      }

      .btn-remove-image-container {
        width: 30px;
        height: 30px;
        justify-content: center;
        display: flex;
        align-items: center;
        background: ${Color.Carnation};
        border-radius: 100%;
        z-index: 1;
      }
    }

    
    .image-wrapper {
      width: 30%;
      margin-right: 5%;
      display: inline-block;

      img {
        border-radius: 4px; 
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }
      
      .isoIcon {
        border: 2px dashed #52c41a;
        text-align: center;
        border-radius: 4px; 
        padding: 20px;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;

      }
    }

        
    .image-wrapper.img-w:after {
      content: "";
      display: block;
      padding-bottom: 100%; /* The padding depends on the width, not on the height, so with a padding-bottom of 100% you will get a square */
    }

    .image-wrapper.img-w {
      position: relative;

      .btn-remove-image-container {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 30px;
        height: 30px;
        justify-content: center;
        display: flex;
        align-items: center;
        background: ${Color.Carnation};
        border-radius: 100%;
        z-index: 1;
      }
    }
    
    .image-wrapper:nth-child(3n+0) {
      margin-right: 0;
    }
    

    .image-wrapper.full-weight:after {
      content: "";
      display: block;
      padding-bottom: 30%;
    }
    
    .image-wrapper.full-weight {
      width: 100%;
      position: relative;
    }
  }

  /*===== End Upload Image Form =====*/
  

  .button-selection button {

    width: 100%;
  }

  .button-selection button.selection {

    text-align: center;
    text-transform: capitalize !important;
    font-size: 16px !important;
    font-weight: bold !important;
    height: 55px !important;

    i {
      
      font-size: 18px;
    }
  }
    
  /*===== Modal Wrap =====*/

  .ant-modal-wrap {
    top: unset;
  }
  
  .ant-modal-wrap.top-20 {
    top: 20%;
  }

  .ant-modal {
    top: unset;
    bottom: 0;
  }

  .ant-modal-content {
    border-radius: 15px;
    width
  }
  /*===== End Modal Wrap =====*/
`;
export default WithDirection(CustomPageStyle);
